import { render, staticRenderFns } from "./ActionPanelDocument.vue?vue&type=template&id=3f32177c&scoped=true"
import script from "./ActionPanelDocument.vue?vue&type=script&lang=js"
export * from "./ActionPanelDocument.vue?vue&type=script&lang=js"
import style0 from "./ActionPanelDocument.vue?vue&type=style&index=0&id=3f32177c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f32177c",
  null
  
)

export default component.exports